export class APIRequestBody<T> {
    model: T;

    constructor(body: T) {
        this.model = body;
    }
}
